<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          Reasons
          <div class="float-right">
            <div class="col">
              <ul class="list-inline mb-0 text-lg-right filter-date-block">
                  <li class="list-inline-item align-middle mt-1 mb-1 ">
                    <CButton color="primary" class="px-4" type="submit" @click="redirectUrls('/reason-list/add')">Add Reason</CButton>
                    <CCol class="col-md-6 float-right">
                    </CCol>
                  </li>
              </ul>
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <stack-modal
                  :show="show"
                  title="DeleteReason"
                  @close="show=false"
                  :hasBackdrop="false"
                  :modal-class="{ [modalClass]: true }"
          >
              <p>Are You sure You want Delete Reason ?</p>
              <slot name="modal-footer">
                <div class="modal-footer">
                    <button class="btn btn-danger" @click="ok">Ok</button>
                    <button class="btn btn-primary" @click="cancel">Cancel</button>
                </div>
            </slot>
            <div slot="modal-footer"></div>
          </stack-modal>
          <loading :active.sync="isLoading"
          :can-cancel="false"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
          <v-client-table v-bind:data="reasonList" v-bind:columns="columns" :options="options" id="dataTable" class="resource-list">
            <span slot="id" slot-scope="props" class="display-link"> {{props.row.id}} </span>
            <span slot="name" slot-scope="props">{{props.row.name}}</span>
            <span slot="createddate" slot-scope="props">{{ props.row.createdAt | momentDate }} </span>
            <span slot="action" slot-scope="props">
                <ul class="list-inline mb-0 text-center">
                    <li class="list-inline-item">
                        <button slot="name" class="edit-link mr-2" @click="redirectUrls('/reason-list/edit/'+props.row.id)" data-toggle="tooltip" data-placement="top" title="Edit">
                          <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                        </button>
                    </li>
                    <li class="list-inline-item">
                        <button slot="name" class="delete-link" @click="DeleteReason(props.row.id)" data-toggle="tooltip" data-placement="top" title="Delete">
                          <font-awesome-icon :icon="['far', 'trash-alt']" />
                        </button>
                    </li>
                </ul>
            </span>
          </v-client-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import VueNotifications from 'vue-notifications'
import StackModal from '@innologica/vue-stackable-modal'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: 'reasonList',
    data() {
        return {
            show: false,
            modalClass: '',
            showAddBtn: true,
            isLoading: false,
            fullPage: true,
            reasonList: [],
            deleteUserId: '',
            columns: ['name', 'createddate', 'action'],
            token: localStorage.getItem('token'),
            API_URL: API_URL,
            APP_URL: APP_URL,
            tokenChange: JSON.parse(localStorage.getItem('token')),
            options: {
              headings: {
                createddate: 'Created Date',
                name: 'Reason',
              },
              sortable: ['name', 'createddate'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              },
              texts:{
                filterPlaceholder:"Search",
                filter:"Search",
                count: "Showing {from} to {to} of {count} records"
                // count: "Showing {from} to {to} of {count} records|{count} records|One record"
              },
            }
        }
    },
    components: {
        Loading,
        StackModal
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    created() {
        document.title = "Reason list";
        this.loadData();
    },
    methods: {
        loadData() {
            this.isLoading = true;
            this.showLoader();
            axios.post(`${API_ADMIN_URL}/adminGetReason/`, {}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.reasonList = response.data.data;
                    this.isLoading = false;
                    this.show = false
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
              this.hideLoader();
            });
        },
        moment: function (date) {
          return moment(date);
        },
        DeleteReason: function(userId) {
          this.deleteUserId = userId;
          this.show=true
        },
        cancel() {
          this.deleteUserId = '';
          this.show = false
        },
        ok() {
          axios.post(`${API_ADMIN_URL}/adminDeleteReason/`, {reasonid: this.deleteUserId}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
              this.isLoading = true;
              if (response.data.status == 200) {
                  this.loadData();
                  this.showSuccessMsg({message: response.data.message});
                  this.isLoading = false;
                  this.show = false
              } else {
                  localStorage.clear();
                  this.$router.push('/login');
              }
          });
        },
        onCancel() {
          // console.log('User cancelled the loader.')
        },
        showLoader: function() {
            this.$isLoading = true;
            this.$emit('loading', true);
        },
        hideLoader: function() {
            this.$isLoading = false;
            this.$emit('loading', false);
        },
        redirectUrls: function(link) {
            this.$router.push(link);
        }
    }
}
</script>
